import { nanoid } from 'nanoid';

export function generateAccessToken() {
  // nanoid already returns URL-safe, high-entropy IDs.
  return nanoid(32);
}
